import React, { useState } from 'react';

import { Box, Typography } from '@mui/material';

import { CommonComponentProps, ImageObject } from '../../pages/types';

interface HeroProps extends CommonComponentProps {
  title?: string;
  subtitle?: string;
  backgroundImage?: ImageObject;
  videoSrc?: string;
}

const Hero: React.FC<HeroProps> = ({
  id,
  title = '',
  subtitle: paragraph = '',
  videoSrc,
  sx,
}) => {
  const [videoLoaded, setVideoLoaded] = useState(false);

  // Extract background image from sx prop if it exists
  const backgroundImage = sx?.backgroundImage;
  const backgroundImageUrl =
    typeof backgroundImage === 'object' && backgroundImage?.url
      ? backgroundImage.url
      : typeof backgroundImage === 'string'
      ? backgroundImage
      : undefined;

  return (
    <Box
      id={id}
      sx={{
        height: '100vh',
        display: 'flex',
        width: '100vw',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        backgroundImage: backgroundImageUrl
          ? `url(${backgroundImageUrl})`
          : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        ...sx,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          padding: '20px 0',
        }}
      >
        <Typography
          variant="h1"
          sx={{
            maxWidth: '950px',
            padding: '0px 0px 10px 0px',
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            maxWidth: '700px',
            padding: '0px 20px 0px 20px',
          }}
        >
          {paragraph}{' '}
        </Typography>
      </Box>
    </Box>
  );
};

export default Hero;
